import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import _ from 'lodash';
import { Tabs } from 'primeng/tabs';
import { forkJoin } from 'rxjs';
import { ProgramTypes } from '../../../../models/_enum-collections';
import { Milestone2PaymentStatus } from '../../../../models/milestone2-payment-status.model';
import {
  SpecialInvestmentsM2PercentageData,
  SpecialInvestmentsM2PercentageMonthData
} from '../../../../models/special-investments-m2-percentage-data.model';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../../common/shared.module';

@Component({
  selector: 'app-m2-percentage-payment-special-investment',
  templateUrl: './app-m2-percentage-payment-special-investment.component.html',
  styleUrls: ['./app-m2-percentage-payment-special-investment.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class AppM2PercentagePaymentSpecialInvestmentComponent
  implements OnInit
{
  @Input() engagementId!: number;
  @Input() isOptOutPartner = true;
  @Input() activityType!: string;
  @Input() isPartnerBlocked!: boolean;
  @Input() partnerMpnid!: number;
  @Input() programTypeId!: number;

  @ViewChild(Tabs, { static: false }) tabView!: Tabs;

  loading = false;

  isReadonlyM65Milestone2Payment = true;
  isReadonlyACRMilestone2Payment = true;
  msgsACRMilestone2InvoiceDetails: any[] = [];
  msgsM365Milestone2Details: any[] = [];
  paymentMilestone2btnNav = false;
  paymentMilestone2DesignationbtnNav = false;
  formSecuritySales!: FormGroup;
  formSecurityACR!: FormGroup;
  formBilledRevenue!: FormGroup;
  formEnabledEngagement!: FormGroup;
  paymentStatuses: Milestone2PaymentStatus[] = [];
  m2Designations: string[] = [];
  monthList: { label: string; value: string }[] = [];
  milestonePayments: SpecialInvestmentsM2PercentageData[] = [];
  acrDataForSelectedMonth!: SpecialInvestmentsM2PercentageMonthData;
  billedRevenueDataForSelectedMonth!: SpecialInvestmentsM2PercentageMonthData;
  updateMilestoneInvoiceDetailsForSelcetedMonth!: SpecialInvestmentsM2PercentageMonthData;
  selectedMonth!: { label: string; value: string };
  datePipe = new DatePipe('en-US');
  maxYearDate!: Date;

  showSecurityACR = false;
  showBilledRevenue = false;
  hasSecurityACR = false;
  hasBilledRevenue = false;
  hasMilestoneData = false;
  hasVaildPayoutMetric = false;
  btnNavM365M2Payment = false;
  btnNavACRM2Payment = false;
  selectedTab = 0;

  constructor(
    private osmEdit: OsmosisEditService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.onFormGroup();
    this.getM2PaymentData(this.engagementId, false);
  }

  editM365M2PaymentDetails() {
    this.togglePaymentDetails('M365');
  }

  editM365M2PaymentCancel(flag = false) {
    this.cancelPaymentDetails('M365', flag);
    this.formBilledRevenue.disable();
  }

  onSubmitM365M2PaymentDetails(formBilledRevenue: FormGroup) {
    this.submitPaymentDetails(formBilledRevenue, 'M365');
  }

  editACRM2PaymentDetails() {
    this.togglePaymentDetails('ACR');
  }

  editACRM2PaymentCancel(flag = false) {
    this.cancelPaymentDetails('ACR', flag);
    this.formSecurityACR.disable();
  }

  onSubmitACRM2PaymentDetails(formSecurityACR: FormGroup) {
    this.submitPaymentDetails(formSecurityACR, 'ACR');
  }

  private togglePaymentDetails(type: string) {
    if (type === 'M365') {
      this.btnNavM365M2Payment = true;
      this.isReadonlyM65Milestone2Payment = false;
      this.formBilledRevenue.enable();
    } else if (type === 'ACR') {
      this.btnNavACRM2Payment = true;
      this.isReadonlyACRMilestone2Payment = false;
      this.formSecurityACR.enable();
    }
  }

  private cancelPaymentDetails(type: string, flag = false) {
    if (type === 'M365') {
      if (!flag) {
        this.msgsM365Milestone2Details = [];
      }
      this.isReadonlyM65Milestone2Payment = true;
      this.btnNavM365M2Payment = false;
    } else if (type === 'ACR') {
      if (!flag) {
        this.msgsACRMilestone2InvoiceDetails = [];
      }
      this.isReadonlyACRMilestone2Payment = true;
      this.btnNavACRM2Payment = false;
    }
    this.onMonthChange(this.selectedMonth);
  }

  private submitPaymentDetails(form: FormGroup, type: string) {
    const msgs =
      type === 'M365'
        ? this.msgsM365Milestone2Details
        : this.msgsACRMilestone2InvoiceDetails;
    msgs.length = 0;

    const paidDateValue = form.controls['paidDate']?.value;
    this.updateMilestoneInvoiceDetailsForSelcetedMonth = {
      engagementId: this.engagementId,
      engagementSubId: form.controls['engagementSubID'].value,
      paymentRecordId: form.controls['paymentRecordId'].value,
      paymentLineItemId: form.controls['paymentLineItemId'].value,
      paymentDocumentNumber: form.controls['paymentDocumentNumber'].value,
      invoice: form.controls['invoiceNumber'].value,
      paymentCentralTransactionId:
        form.controls['paymentCentralTransactionId'].value,
      eventTypeId: form.controls['eventTypeId'].value,
      status: form.controls['paymentStatus'].value,
      payoutMetric: form.controls['payoutMetric'].value,
      paidDate: paidDateValue ? new Date(paidDateValue) : new Date(''),
      paymentAmount: form.controls['paymentAmount'].value
    };

    this.osmEdit
      .UpdateM2PaymentInvoiceDetail(
        this.updateMilestoneInvoiceDetailsForSelcetedMonth
      )
      .subscribe(
        apiResponse => {
          if (apiResponse.success) {
            msgs.push({ severity: 'success', detail: apiResponse.message });
          } else {
            msgs.push({ severity: 'error', detail: apiResponse.message });
          }
          this.getM2PaymentData(this.engagementId, true);
          if (type === 'M365') {
            this.isReadonlyM65Milestone2Payment = true;
            this.btnNavM365M2Payment = false;
            this.formBilledRevenue.disable();
          } else {
            this.isReadonlyACRMilestone2Payment = true;
            this.btnNavACRM2Payment = false;
            this.formSecurityACR.disable();
          }
        },
        () => {
          msgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Invoice Details'
          });
        }
      );
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formSecurityACR = this.formBuilder.group({
      payoutMetric: [''],
      paymentAmount: [''],
      paidDate: [''],
      paymentDocumentNumber: [''],
      invoiceNumber: [''],
      paymentStatus: [''],
      paymentCentralTransactionId: [''],
      engagementSubID: [''],
      paymentLineItemId: [''],
      paymentRecordId: [''],
      eventTypeId: ['']
    });
    this.formSecurityACR.disable();

    this.formBilledRevenue = this.formBuilder.group({
      payoutMetric: [''],
      paymentAmount: [''],
      paidDate: [''],
      paymentDocumentNumber: [''],
      invoiceNumber: [''],
      paymentStatus: [''],
      paymentCentralTransactionId: [''],
      engagementSubID: [''],
      paymentLineItemId: [''],
      paymentRecordId: [''],
      eventTypeId: ['']
    });

    this.formBilledRevenue.disable();
  }

  getM2PaymentData(engagementId: number, isRefresh) {
    this.loading = true;
    const m2PercentageDataFetch =
      this.osmEdit.getSpecialInvestmentsM2PercentageData(engagementId);
    const paymentStatusListFetch =
      this.osmEdit.getCsiMilestone2PaymentStatusDropdown();

    forkJoin([paymentStatusListFetch, m2PercentageDataFetch]).subscribe(
      results => {
        this.loading = false;
        this.paymentStatuses = results[0];
        const milestonePayments = results[1];

        if (!milestonePayments) {
          this.hasMilestoneData = false;
          return;
        }

        this.m2Designations = milestonePayments.map(m => m.payoutMetric);
        this.milestonePayments = milestonePayments;

        this.getMonthList(milestonePayments);
        this.setACRPaymentData(isRefresh);
        this.setBilledRevenuePaymentData(isRefresh);
      }
    );
  }

  getMonthList(milestonePayments: SpecialInvestmentsM2PercentageData[]) {
    let monthList;
    this.monthList = [];
    const monthOrder = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];

    milestonePayments.forEach(paymentData => {
      monthList = _.union(monthList, paymentData.monthList);
    });

    monthList.forEach(m => {
      this.monthList.push({ label: m, value: m } as any);
    });

    if (this.monthList && this.monthList.length == 0) {
      return;
    }

    this.monthList = this.monthList.sort((a, b) => {
      const x = { month: a.value.slice(0, 3), year: a.value.slice(4, 8) };
      const y = { month: b.value.slice(0, 3), year: b.value.slice(4, 8) };

      if (x.year !== y.year) {
        return parseInt(x.year) - parseInt(y.year);
      }
      return monthOrder.indexOf(x.month) - monthOrder.indexOf(y.month);
    });

    if (!this.selectedMonth || this.selectedMonth === null) {
      this.selectedMonth = this.monthList[0];
    }
  }

  onMonthChange(selectedMonth) {
    this.selectedMonth = selectedMonth;
    this.showSecurityACR = false;
    this.showBilledRevenue = false;
    this.setACRPaymentData(false);
    this.setBilledRevenuePaymentData(false);
    this.msgsACRMilestone2InvoiceDetails = [];
    this.msgsM365Milestone2Details = [];

    if (this.btnNavACRM2Payment) {
      this.btnNavACRM2Payment = !this.btnNavACRM2Payment;
      this.isReadonlyACRMilestone2Payment =
        !this.isReadonlyACRMilestone2Payment;
    }
  }

  setACRPaymentData(isRefresh: boolean) {
    const acrData = _.find(
      this.milestonePayments,
      m => m.payoutMetric == 'ACR'
    );

    if (
      acrData != null &&
      acrData.monthList.includes((this.selectedMonth as any).value)
    ) {
      const foundAcrData = acrData.m2PercentageMonthData.find(
        m => m.month == (this.selectedMonth as any).value
      );
      this.showSecurityACR = true;

      if (foundAcrData) {
        this.acrDataForSelectedMonth = foundAcrData;
        this.buildM2PaymentForm(
          {
            milestonePayment: this.acrDataForSelectedMonth,
            engagementSubId: acrData.engagementSubId,
            paymentRecordId: acrData.paymentRecordId,
            eventTypeId: acrData.eventTypeId
          },
          false,
          isRefresh
        );
      } else {
        this.showSecurityACR = false;
      }

      if (!isRefresh) {
        this.setSelectedTab();
      }
    }
  }

  setBilledRevenuePaymentData(isRefresh: boolean) {
    const billedRevenueData = _.find(
      this.milestonePayments,
      m => m.payoutMetric == 'Billed Revenue'
    );

    if (
      billedRevenueData != null &&
      billedRevenueData.monthList.includes((this.selectedMonth as any).value)
    ) {
      const foundBilledRevenueData =
        billedRevenueData.m2PercentageMonthData.find(
          m => m.month == (this.selectedMonth as any).value
        );
      this.showBilledRevenue = true;

      if (foundBilledRevenueData) {
        this.billedRevenueDataForSelectedMonth = foundBilledRevenueData;
        this.buildM2PaymentForm(
          {
            milestonePayment: this.billedRevenueDataForSelectedMonth,
            engagementSubId: billedRevenueData.engagementSubId,
            paymentRecordId: billedRevenueData.paymentRecordId,
            eventTypeId: billedRevenueData.eventTypeId
          },
          true,
          isRefresh
        );
      } else {
        this.showBilledRevenue = false;
      }

      if (!isRefresh) {
        this.setSelectedTab();
      }
    }
  }
  private minDate = new Date(
    'Mon Jan 01 2001 00:00:00 GMT+0530 (India Standard Time)'
  );

  formatPaidDate(paidDate: Date): string {
    const paidFormattedDate = this.datePipe.transform(paidDate, 'MM/dd/yyyy');
    const transformedDateObj = new Date(paidFormattedDate || '');
    return transformedDateObj > this.minDate ? paidFormattedDate || '' : '';
  }

  setSelectedTab() {
    if (
      this.showSecurityACR ||
      (this.showSecurityACR && this.showBilledRevenue)
    ) {
      this.selectedTab = 0;
    } else {
      this.selectedTab = 1;
    }
  }

  buildM2PaymentForm(
    {
      milestonePayment,
      engagementSubId,
      paymentRecordId,
      eventTypeId
    }: {
      milestonePayment: SpecialInvestmentsM2PercentageMonthData;
      engagementSubId: string;
      paymentRecordId: string;
      eventTypeId: number;
    },
    foundBilledRevenueData: boolean,
    isRefresh: boolean
  ) {
    const paidFormattedDate = this.formatPaidDate(milestonePayment.paidDate);
    const form = {
      payoutMetric: milestonePayment.payoutMetric,
      paymentAmount: milestonePayment.paymentAmount,
      paidDate: paidFormattedDate,
      invoiceNumber: milestonePayment.invoice,
      paymentCentralTransactionId: milestonePayment.paymentCentralTransactionId,
      paymentDocumentNumber: milestonePayment.paymentDocumentNumber,
      paymentStatus: milestonePayment.status,
      engagementSubID: milestonePayment.engagementSubId ?? engagementSubId,
      paymentLineItemId: milestonePayment.paymentLineItemId,
      paymentRecordId: paymentRecordId,
      eventTypeId: eventTypeId
    };

    if (!foundBilledRevenueData) {
      this.formSecurityACR.patchValue(form);
    } else {
      this.formBilledRevenue.patchValue(form);
    }

    if (!isRefresh) {
      this.setSelectedTab();
    }
    this.hasMilestoneData = true;
  }

  get ProgramType() {
    return ProgramTypes;
  }
}
